import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SNIPPIT_API_URL } from '../App';
import './retro.css';

type Station = {
  id: string;
  title: string;
  image: string;
};

export default function StationsView() {
  const navigate = useNavigate();
  const [stations, setStations] = useState<Station[]>([]);
  const [loading, setLoading] = useState(true);
  const [shuffling, setShuffling] = useState(false);

  const fetchStations = async () => {
    setShuffling(true);
    try {
      const res = await fetch(`${SNIPPIT_API_URL}/api/radio/stations?count=6`);
      if (!res.ok) throw new Error('Failed to fetch stations');
      const data: Station[] = await res.json();
      setStations(data);
    } catch {
      console.error('Failed to load stations');
    } finally {
      setLoading(false);
      setShuffling(false);
    }
  };

  useEffect(() => {
    fetchStations();
  }, []);

  const handleSelectStation = (station: Station) => {
    navigate('/loading', {
      state: {
        url: `${SNIPPIT_API_URL}/api/radio/${station.id}/tracks?count=5`,
        contextName: station.title,
        backPath: '/stations',
        gameMode: 'artist'
      }
    });
  };

  return (
    <div className="landing-root">
      <div className="grain" />
      <div className="vignette" />

      <div className="landing-inner">
        <div className="logo-block">
          <div className="logo-eyebrow">♪ tune in ♪</div>
          <h1 className="logo">SNIPPIT</h1>
          <div className="logo-sub">pick a station · guess the songs</div>
        </div>

        <div className="stations-block">
          <div className="stations-header">
            <span className="field-label">PICK A STATION</span>
            <button className="shuffle-btn" onClick={fetchStations} disabled={shuffling}>
              {shuffling ? '...' : '⟳ SHUFFLE'}
            </button>
          </div>

          {loading ? (
            <div className="stations-loading">TUNING IN...</div>
          ) : (
            <div className="stations-grid">
              {stations.map(station => (
                <button
                  key={station.id}
                  className="station-card"
                  onClick={() => handleSelectStation(station)}
                >
                  <img src={station.image} alt={station.title} className="station-img" />
                  <div className="station-title">{station.title}</div>
                </button>
              ))}
            </div>
          )}
        </div>

        <button className="back-btn" onClick={() => navigate('/')}>← BACK</button>
      </div>
    </div>
  );
}